module.exports = emuiUserMonitoring;